<template>
  <base-modal
    :id="modalId"
    :ok-handler="okHandler"
    :title="modalTitle"
    @showModal="onShowModal"
  >
    <div>
      <p>Create a new user</p>
      <spinner :show="isLoading" />
      <div v-if="error">
        <p class="error-text">{{ error }}</p>
      </div>
      <form ref="createUserForm" class="sa-form" :show="!isLoading" @submit.prevent="onSubmit">
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="name">Full Name<span class="label-required">*</span></label>
            <input
              id="name"
              v-model="name"
              class="form-control"
              type="text"
              placeholder="Name"
              required="true"
              autocomplete="off"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="email">Email<span class="label-required">*</span></label>
            <input
              id="email"
              v-model="email"
              class="form-control"
              type="email"
              placeholder="me@example.com"
              required="true"
              autocomplete="off"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="phoneNum">Phone number<span class="label-required">*</span></label>
            <input
              id="phoneNum"
              v-model="phoneNum"
              class="form-control"
              type="tel"
              maxlength="12"
              pattern="([0-9]{3}-[0-9]{3}-[0-9]{4})|[0-9]{10}"
              title="Please match the following 10-digit format: 555-555-5555"
              placeholder="___-___-____"
              required="true"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="organization">Organization<span class="label-required">*</span></label>
            <select
              id="organization"
              v-model="organization"
              class="form-control"
              required="true"
            >
              <option>Select One</option>
              <option v-for="org in orgs" :key="org.id" :value="org.id">
                {{ org.name }}
              </option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="title">Title<span class="label-required">*</span></label>
            <input
              id="title"
              v-model="title"
              class="form-control"
              type="text"
              placeholder="Title"
              required="true"
            />
          </div>
          <!-- TODO: vif the SA Org is selected maybe this isn't needed at all -->
          <div class="form-group col-md-4">
            <div class="user-checkbox">
              <input
                id="role"
                v-model="role"
                type="checkbox"
              />
              <label for="role">Is Admin</label>
            </div>
          </div>
        </div>
      </form>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal';
import roles from '../../util/roles';
import Spinner from '../Spinner';
import reportValidity from 'report-validity';

export default {
  name: 'CreateUserModal',
  components: { BaseModal, Spinner },
  data() {
    return {
      modalId: 'create-user-modal',
      modalTitle: this.userToUpdate ? 'Update User' : 'Create User',
      name: '',
      title: '',
      email: '',
      organization: '',
      phoneNum: '',
      role: false
    }
  },
  computed: {
    orgs: function() {
      return this.$store.getters.getOrgs;
    },
    isLoading: function() {
      return this.$store.getters.getIsUsersLoading;
    },
    error: function() {
      return this.$store.getters.getUserError;
    },
    userToUpdate() {
      return this.$store.getters.getUserToUpdate;
    },
  },
  mounted() {
    if (this.$store.getters.getUser) {
      this.$store.dispatch('listOrgs');
    }

    // HACK: Since modals are mounted immediately, we dont know the ids to use yet so this pushs the API call until the modal is shown
    const handleShow = this.handleShow;
    const handleClose = this.handleClose;
    this.$root.$on('bv::modal::show', handleShow);
    this.$root.$on('bv::modal::hide', handleClose);
  },
  methods: {
    handleShow: function(bvModalEvt) {
      if (bvModalEvt.componentId === this.modalId) {
        if (this.userToUpdate) {
          this.name = this.userToUpdate.name;
          this.email = this.userToUpdate.email;
          this.title = this.userToUpdate.title;
          this.organization = this.userToUpdate.organization;
          this.phoneNum = this.userToUpdate['phone_number'].replace('+1', '');
          this.role = this.userToUpdate.role === roles.ADMIN;
        }
      }
    },
    handleClose: function(bvModalEvt) {
      if (bvModalEvt.componentId === this.modalId) {
        this.$store.dispatch('clearUserState');
        this.resetData();
      }
    },
    isValid: function(values) {
      if (!values.organization) return false;

      return true;
    },
    handleSubmit: function(e) {
      if (e) e.preventDefaul();
      const values = {
        organization: this.organization,
        title: this.title,
        role: this.role ? roles.ADMIN : roles.USER,
        name: this.name,
        email: this.email,
        phone_number: `+1${this.phoneNum.replace(/[^0-9]/g,'')}`
      };
      if (this.isValid(values)) {
        // TODO: Some API Action Here
        // TODO: Depending on the status of the action, close the modal, or pass the closer as a callback
        const payload = {
          vm: this,
          user: values,
          cb: this.closeModal
        };

        if (this.userToUpdate) {
          this.$store.dispatch('updateUser', payload);
        } else {
          this.$store.dispatch('createUser', payload);
        }
      }
    },
    onShowModal() {
      this.$store.dispatch('listOrgs');
    },
    okHandler: function(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (this.$refs.createUserForm) {
        let isValidForm = reportValidity(this.$refs.createUserForm);
        if (isValidForm) {
          this.handleSubmit();
        }
      }
    },
    closeModal: async function() {
      await this.$nextTick();
      this.resetData();
      this.$store.dispatch('clearUserState');
      this.$bvModal.hide(this.modalId);
    },
    resetData: function() {
      this.title = '';
      this.name =  '';
      this.email = '';
      this.organization = 'f6d66a62-f684-44ae-b881-e22c7a9b1002'; // TODO: This needs to be passed in through process.env
      this.phoneNum = '';
      this.role = false;
    }
  },
}
</script>
